import styled from 'styled-components';
import { Tabs } from 'react-tabs';
import { margin } from 'styled-system';
import { MarginProps } from '../../../theme/styledProps';

export const Steps = styled(Tabs)<MarginProps>(margin);
